// ============================================
// SECTION — Services
// ============================================

import {
  RiGraduationCapLine,
  RiBarChartBoxLine,
  RiMicroscopeLine,
  RiBriefcaseLine,
  RiTeamLine,
  RiMicLine,
  RiArrowRightLine,
} from "react-icons/ri";
import { SERVICES } from "../data/content";
import { useInView } from "../hooks/useInView";
import "./Services.css";

const ICON_MAP = {
  workshops:  <RiGraduationCapLine />,
  evaluation: <RiBarChartBoxLine />,
  research:   <RiMicroscopeLine />,
  reentry:    <RiBriefcaseLine />,
  family:     <RiTeamLine />,
  speaking:   <RiMicLine />,
};

const scrollTo = (id) =>
  document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

export default function Services() {
  const [ref, visible] = useInView(0.1);

  return (
    <section id="services" className="services section-pad">
      <div className="container">
        <div className={`fade-up ${visible ? "visible" : ""}`}>
          <span className="section-label">What We Offer</span>
          <h2 className="section-title">Our Services</h2>
          <p className="section-sub">
            Comprehensive, research-grounded solutions for agencies, organizations,
            and communities working at the intersection of justice and family.
          </p>
        </div>

        <div ref={ref} className="services__grid">
          {SERVICES.map((service, i) => (
            <div
              key={service.id}
              className={`service-card stagger-child ${visible ? "visible" : ""}`}
              style={{ transitionDelay: `${i * 0.1}s` }}
            >
              <div className="service-card__icon">
                {ICON_MAP[service.iconKey]}
              </div>
              <h3 className="service-card__title">{service.title}</h3>
              <p className="service-card__desc">{service.desc}</p>
              <button
                className="service-card__link"
                onClick={() => scrollTo("contact")}
              >
                Learn More <RiArrowRightLine />
              </button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
